<!-- SetupComponentsのテンプレートを書いておくのでこれ使って新規コンポーネント作成してくれると嬉しいです(改善等あれば随時変更してください) -->
<script lang="ts" setup>
import { i18n } from '@/i18n';
import { ref, watch } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';

// props
const props = withDefaults(
  defineProps<{
    modalState?: boolean;
  }>(),
  {
    modalState: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'canceled'): void;
  (e: 'confirm', cancelReason: string): void;
}>();

//変数
const t = i18n.t;
const selectedConfirm = ref<boolean>(false);
const cancelReason = ref<string>('');

/**
 * キャンセル理由を更新する
 * @param value - キャンセル理由
 */
const updateCancelReason = (value: Event) => {
  const target = value.target as HTMLTextAreaElement;
  cancelReason.value = target.value;
};

watch(
  () => props.modalState,
  (newVal, oldVal) => {
    // false -> true になった場合、変数を初期化する
    if (oldVal === false && newVal === true) {
      selectedConfirm.value = false;
      cancelReason.value = '';
    }
  }
);
</script>

<template>
  <!-- outside-clickは無効にしてる -->
  <Modal
    class="confirm-modal-container"
    :modal-size="'max-content'"
    :modal-width="500"
    :aspect-ratio="true"
    :stretch-container="true"
    :scroll-off="true"
    :padding="'16px'"
    :modal-state="modalState"
    :border-radius="'16px'"
    :md-click-out-side-to-close="false"
  >
    <div class="delete-order-content">
      <img class="delete-order-content__icon" src="@/assets/img/error_outline.png" />
      <span class="delete-order-content__title">
        {{ t('納期または発注数量が確定してるものが削除対象に含まれています。') }}
      </span>
      <span class="delete-order-content__label">
        {{ t('以下の合意があることを確認してから対象を削除してください。') }}
      </span>

      <RowCheckBox
        v-model="selectedConfirm"
        :label-text="t('仕入先との発注キャンセルの合意')"
        class="delete-order-content__confirm-check-box confirm-check-box"
        :is-checked="selectedConfirm"
        @change-status="selectedConfirm = $event"
      />

      <!-- TODO: 24/08/11 キャンセル受け入れ理由等のデータの取り回しが未見当のため非表示。 -->
      <!-- <div class="delete-order-content__cancel-reason cancel-reason">
        <span class="cancel-reason__label">
          {{ t('キャンセル受け入れ理由（任意）') }}
        </span>
        <textarea class="cancel-reason__input-field" rows="10" name="memo" @input="updateCancelReason" />
      </div> -->

      <div class="delete-order-content__button-container button-container">
        <TextButton
          :button-style="'btn-secondary-error'"
          :size="'btn-md'"
          :on-click="() => emits('canceled')"
          class="button-container--cancel-button"
        >
          {{ t('キャンセル') }}
        </TextButton>
        <TextButton
          :button-style="'btn-error'"
          :size="'btn-md'"
          :disabled="!selectedConfirm"
          :on-click="() => emits('confirm', cancelReason)"
          class="button-container--confirm-button"
        >
          {{ t('削除') }}
        </TextButton>
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
.delete-order-content {
  height: 100%;
  display: grid;
  grid-template-rows: repeat(5, fit-content(20%));
  justify-items: center;
  row-gap: 24px;

  &__icon {
  }
  &__title {
    font-size: 22px;
    font-weight: bold;
    line-height: 28px;
    color: $textDefault;
    padding: 0px 32px;
    text-align: center;
  }
  &__label {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: $textDefault;
  }
  &__confirm-check-box {
    width: 24px;
    height: 24px;
  }
  &__cancel-reason {
  }
}

.confirm-check-box {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  width: 100%;
  column-gap: 4px;
  align-items: center;
}

.cancel-reason {
  display: grid;
  grid-template-rows: repeat(2, max-content);
  width: 100%;
  justify-items: baseline;
  row-gap: 8px;

  &__label {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }
  &__input-field {
    width: 100%;
    height: 100%;
    padding: 8px;
    border: 1px solid $borderDefault;
    border-radius: 4px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }
  textarea {
    height: calc(1.42 * 6em);
    line-height: 1.42;
    resize: none;
  }
}

.header {
  display: grid;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  justify-items: center;
  gap: 16px;
  &__title {
    font-size: 22px;
    font-weight: bold;
    line-height: 28px;
  }
  &__description {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }
}

.checked-container {
  display: grid;
  grid-template-rows: repeat(2, fit-content(20%));
  align-items: center;
  justify-items: center;
  align-content: center;
  gap: 8px;
  &__image {
    width: 40px;
    height: 40px;
  }
  &__text {
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    color: $semanticWhite;
  }
}

.button-container {
  display: grid;
  grid-template-columns: repeat(2, fit-content(50%));
  justify-self: center;
  gap: 16px;
  &--cancel-button {
    padding: 12px 32px 12px 32px;
  }
  &--confirm-button {
    padding: 12px 56px 12px 56px;
  }
}
</style>
